import { ConnectionsSection } from "./connections-section.js";
import { PreferencesForm } from "./preferences-form.js";

export function SettingsPage() {
  return (
    <section className="page-stack page-stack--compact" aria-label="Settings">
      <h1>Settings</h1>
      <ConnectionsSection />
      <PreferencesForm />
    </section>
  );
}
